<p-chart type="line" :data="data" :options="options"></p-chart>